import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageService } from './storage.service';
import * as jwt_decode from 'jwt-decode';

import { environment } from "environments/environment";
import { lastValueFrom, Subscription } from 'rxjs';
import { AccessData, AccountItem } from '../models/accessData.model';
import { GS1LoadingService } from '@gs1france/gs1-components-library';
 let __URL_API__  = `${environment.URL_API}`; 

 @Injectable({providedIn: 'root'})
 export class TokenGS1Service implements OnDestroy {
    selectedCompany : AccountItem;
    subs: Subscription[] = [];

    constructor(private _http: HttpClient, private storageService: StorageService, private loadingService: GS1LoadingService) {}
    
    async getTokenGS1(idCompany:string): Promise<void> {
        const data = await this.storageService.getAccessData();
        if(data)
        {
        this.loadingService.startLoading('gs1-token');
        for (const account of data.accounts) {
            if (account.idCompany === idCompany) {
                this.selectedCompany = account;
                this.setContactField(data);
            }
        }
    }
        try {
             var body = JSON.stringify(this.selectedCompany);
             var params = new HttpParams().set('idCompany', String(idCompany));
             const headers = { 'content-type': 'application/json'}  
             this.getTokenGS1Admin().then(x => {
                let tokenGS1 = x;
            //let tokenGS1 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50TnVtYmVyIjoiQ0xULTAwNDIzMDIiLCJhY2NvdW50TmFtZSI6IlNDSSBRVUFJIFdFU1QiLCJ0eXBlQ29tcHRlIjoiR1MxIEZyYW5jZSIsImVtYWlsIjoidGVzdGF1dG82NjczQHlvcG1haWwuY29tIiwicm9sZSI6IltcImFkbWluaXN0cmF0ZXVyXCIsXCJ1dGlsaXNhdGV1clwiXSIsImdsbiI6IjM3NzAwMjc1MTQwMTUiLCJzaXJlbiI6IjgwMzYwODEyNCIsImZpcnN0bmFtZSI6ImRlbW8xMSIsImxhc3RuYW1lIjoiQXV0bzExIiwiY2l2aWxpdGUiOiJNb25zaWV1ciIsImFjdGl2aXRlIjoiR3Jvc3Npc3RlIC8gTsOpZ29jaWFudCAvIEltcG9ydGF0ZXVyIiwiYWNjZXNzRmljaGVQYXJ0ZW5haXJlIjoiRmFsc2UiLCJjb3VudHJ5IjoiRlJBTkNFIiwiaWRDb21wYW55IjoiMjYxZGM5NjMtMjcwOS00Y2RjLWI3ZDEtODlkMmFlYmE5ZTMwIiwiaWRDb250YWN0IjoiMjc5ZDc4NjEtYjJhMC00Njg5LTQwNTMtMDhkYWFjZmU4ZmVmIiwibmJmIjoxNjcxNTUyMjg5LCJleHAiOjE2NzE2Mzg2ODksImlhdCI6MTY3MTU1MjI4OX0._nNjXePdZyOoRdCDKMR2pD4U-hZd1Pe4zdkUlGcN8uU";

            let tokenInfoPerso = jwt_decode(tokenGS1);

            let roles = JSON.parse(tokenInfoPerso.role) as string[];
            this.storageService.setGS1Token(tokenGS1,this.selectedCompany);
            this.storageService.setSession(tokenInfoPerso);
            this.storageService.remove("apimSsoKey");
            this.loadingService.stopLoading('gs1-token');
             });
             
        } catch (error) {
            
            return await this.handleError(error);
        }

    }
    ngOnDestroy(): void {
        this.subs.forEach(sub => sub.unsubscribe());
      }

      async getTokenGS1Admin(): Promise<string> {
        try {
          let response = await this._http.get(__URL_API__ + 'api/GS1Token/GetTokenAdmin').toPromise();
            let tokenGS1 = response as string;

          localStorage.setItem('tokenGS1Admin', tokenGS1);

            return tokenGS1;
        } catch (error) {
            return '';
        }

    }
  
    private setContactField(data : AccessData) {
        this.selectedCompany.contact.email = data.contactEmail;
        this.selectedCompany.contact.gender = data.contactGender == "Monsieur" ? 860330000 : 860330001;
        this.selectedCompany.contact.firstName = data.contactFirstName;
        this.selectedCompany.contact.lastName = data.contactLastName;
        this.selectedCompany.contact.mobilePhone = data.mobilePhone;
        this.selectedCompany.contact.profesionalPhone = data.profesionalPhone;
    }

    public handleError(error: any): Promise<any> {
        console.error(error)
        this.loadingService.stopLoading('gs1-token');
        return Promise.reject(error.message || error);
    }

}